import type { AnalyticsProvider, AnalyticsServiceProvider, AnalyticsTrackOptions } from '~analytics/types/analyticsProvider';

export const useAnalyticsServiceProvider = (
  baseEventData?: () => object,
): AnalyticsServiceProvider => {
  const providers = ref<AnalyticsProvider[]>([]);

  const defaultEventData = () => ({});
  const getBaseEventData = baseEventData || defaultEventData;

  const track = (eventName: string, specificEventData: object = {}, options?: AnalyticsTrackOptions) => {
    if (!import.meta.client) {
      return;
    }

    const eventData = { ...getBaseEventData(), ...specificEventData };

    providers.value.forEach((provider) => {
      if (provider.getSubscribedEvents().includes(eventName)) {
        try {
          provider.track(eventName, eventData, options);
        }
        catch (error) {
          console.error(error);
        }
      }
    });
  };

  const identify = (guid: string | undefined) => {
    if (!import.meta.client) {
      return;
    }

    providers.value.forEach((provider) => {
      try {
        provider.identify(guid);
      }
      catch (error) {
        console.error(error);
      }
    });
  };

  const reset = () => {
    if (!import.meta.client) {
      return;
    }

    providers.value.forEach((provider) => {
      try {
        provider.reset();
      }
      catch (error) {
        console.error(error);
      }
    });
  };

  const setUserProperties = (properties: Record<string, unknown>) => {
    if (!import.meta.client) {
      return;
    }
    providers.value.forEach((provider) => {
      try {
        provider.setUserProperties(properties);
      }
      catch (error) {
        console.error(error);
      }
    });
  };

  const registerProvider = async (provider: AnalyticsProvider) => {
    await provider.init();
    providers.value.push(provider);
  };

  return {
    track,
    identify,
    reset,
    registerProvider,
    getBaseEventData,
    setUserProperties,
  };
};
